/* eslint-disable */
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { User } from '@angular/fire/auth';
import { from, map, Observable, of, switchMap } from 'rxjs';
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import { AUTH_CLIENT_TOKEN, AuthClientProvider, PLATFORM_TOKEN, PlatformProvider } from '@core';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly authClientProvider: AuthClientProvider = inject(AUTH_CLIENT_TOKEN);
  private readonly platformProvider: PlatformProvider = inject(PLATFORM_TOKEN);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.getIdToken().pipe(
      map((token) => (token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req)),
      switchMap((finalReq) => next.handle(finalReq))
    );
  }

  private getIdToken(): Observable<string | null> {
    if (this.platformProvider.isNativeRun) {
      return from(
        FirebaseAuthentication.getIdToken()
          .then((result) => result.token)
          .catch(() => null)
      );
    }

    const user: User | null = this.authClientProvider.authClient.currentUser;
    return user ? from(user.getIdToken()) : of(null);
  }
}
